import Vue from 'vue';
import Vuex from 'vuex';
import { rest, endpoint_host } from '@/config';


Vue.use(Vuex);


export const state = {
    flags: [],
    selos: [],
    tipos: {
        aluguel: [],
        venda: []
    },

};
export const actions = {
    async load({ dispatch }) {
        dispatch('loadSelos');
        dispatch('loadFlags');
        dispatch('loadTipos', 'aluguel');
        dispatch('loadTipos', 'venda');
    },
    async loadSelos({ dispatch }) {
        
        return fetch(`${endpoint_host}/selos`)
            .then(resp => resp.json())
            .then(({selos}) => {
                
                return dispatch('setSelos', selos);
            })
            .catch(err => {
                console.error(err);
            })
    },
    async loadFlags({ dispatch }) {
        return fetch(`${rest.endpoint}/flags.json?t=${Date.now()}`)
            .then(resp => resp.json())
            .then(flags => {
                return dispatch('setFlags', flags);
            })
            .catch(err => {
                console.error(err);
            })
    },
    async loadTipos({ dispatch }, finalidade) {
        return fetch(`${rest.endpoint}/${finalidade}/tipos.json?t=${Date.now()}`)
            .then(resp => resp.json())
            .then(({ comercial = {}, residencial = {}, lancamentos = {}, prontos = {} }) => {
                let tipos = [
                    ...Object.values(comercial), 
                    ...Object.values(residencial),
                    ...Object.values(lancamentos), 
                    ...Object.values(prontos)
                ];

                return dispatch('setTipos', {tipos, finalidade});
            })
            .catch(err => {
                console.error(err);
            });
    },
    async setTipos({ commit }, {tipos, finalidade}) {
        commit('setTipos', {tipos, finalidade});
    },
    async setFlags({ commit }, flags) {
        commit('setFlags', flags);
    },
    async setSelos({ commit }, selos) {
        commit('setSelos', selos);
    }
};
export const mutations = {   
    setTipos(state, {tipos, finalidade}) {
        state.tipos[finalidade] = tipos;
    },
    setFlags(state, flags) {
        state.flags = flags;
    },
    setSelos(state, selos) {
        
        state.selos = selos;
    }
};
export const getters = {    
};
export const modules = {};
export const store = new Vuex.Store({
    state,
    actions,
    mutations,
    getters,
    modules
});
export default store;

store.dispatch('load');